import {memo} from 'react';

import {Form} from 'react-final-form';

import FormRender from './FormRender';

const FormWrapper = ({loading, editedAddress, onSubmit, ...props}) => {
  const {
    isCompanyAddress,
    cityId,
    streetId,
    phone01,
    cellPhone,
    locationType,
    addressType,
    locationName,
    addressTypeName,
    comments,
  } = editedAddress;

  const initialValues = {
    ...editedAddress,
    cityId: cityId || 0,
    streetId: streetId || 0,
    phoneNumber: cellPhone || phone01,
    locationType: locationType || addressType,
    locationName: locationName || addressTypeName,
    comments,
  };

  return (
    <Form
      {...{initialValues, onSubmit}}
      render={({handleSubmit, invalid, values, visited, form}) => (
        <FormRender {...{
          handleSubmit,
          invalid,
          values,
          visited,
          isCompanyAddress,
          form,
          loading,
          ...props,
        }}
        />
      )}
    />
  );
};

export default memo(FormWrapper);
